import React from "react";
import { ButtonComponent } from "../elements";

export default function IconFieldComponent({value, classes, icon, option, activeOption, type, placeholder, passwordVisible,handleChange, ...rest }) {
    
    const [visible, setVisible] = React.useState(false);
    
    
    return (
        <div className={`mc-icon-field ${ classes || "w-md h-sm" }`}>
            <i className="material-icons">{icon || 'account_circle'}</i>
            {type ?
                <>
                    <input 
                    value={value}
                    onChange={handleChange}
                        type={ visible ? "text" : type || "text" }  
                        placeholder={ type ? placeholder || "Type here..." : "" } 
                        { ...rest } 
                    />
                    {passwordVisible && 
                        <ButtonComponent 
                            type = "button"
                            className = "material-icons"
                            onClick = {()=> setVisible(!visible)}
                        >
                            { visible ? "visibility_off" : "visibility" }
                        </ButtonComponent>
                    }
                </>
                :
                <select onChange={handleChange} style={{ backgroundImage: 'url(/images/dropdown.svg)' }} { ...rest }>
                    <option>{ activeOption || "Select Option" }</option>
                    {option.map((item, index) => (
                        <option key={ index } value={ item.code }>{ item.name}</option>
                    ))}
                </select>
            }
       </div>
    )
}